import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=3d28504e&"
import script from "./SettingsModal.vue?vue&type=script&lang=ts&"
export * from "./SettingsModal.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports